/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardTemplateSummary } from './ScorecardTemplateSummary.js';
import {
    ScorecardTemplateSummaryFromJSON,
    ScorecardTemplateSummaryFromJSONTyped,
    ScorecardTemplateSummaryToJSON,
} from './ScorecardTemplateSummary.js';

/**
 * 
 * @export
 * @interface ScorecardTemplateSummarySingleResponse
 */
export interface ScorecardTemplateSummarySingleResponse {
    /**
     * 
     * @type {ScorecardTemplateSummary}
     * @memberof ScorecardTemplateSummarySingleResponse
     */
    data?: ScorecardTemplateSummary;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummarySingleResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummarySingleResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummarySingleResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScorecardTemplateSummarySingleResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScorecardTemplateSummarySingleResponse interface.
 */
export function instanceOfScorecardTemplateSummarySingleResponse(value: object): boolean {
    return true;
}

export function ScorecardTemplateSummarySingleResponseFromJSON(json: any): ScorecardTemplateSummarySingleResponse {
    return ScorecardTemplateSummarySingleResponseFromJSONTyped(json, false);
}

export function ScorecardTemplateSummarySingleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardTemplateSummarySingleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScorecardTemplateSummaryFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScorecardTemplateSummarySingleResponseToJSON(value?: ScorecardTemplateSummarySingleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScorecardTemplateSummaryToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

